import { render, staticRenderFns } from "./Welcome.vue?vue&type=template&id=684262ec&scoped=true&"
import script from "./Welcome.vue?vue&type=script&lang=js&"
export * from "./Welcome.vue?vue&type=script&lang=js&"
import style0 from "./Welcome.vue?vue&type=style&index=0&id=684262ec&lang=scss&scoped=true&"
import style1 from "./Welcome.vue?vue&type=style&index=1&id=684262ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684262ec",
  null
  
)

export default component.exports